import { isTRPCClientError } from '@trpc/client'

import { ensureError, TechnicalError } from '@orus.eu/error'

type SerializedError = Record<string, string | number | boolean | null>

/**
 * Flattens an error into logger metadata: Firefox stacks carry no message, and cause chains, tRPC
 * response details and `TechnicalError` contexts do not survive naive stringification.
 */
export function serializeError(error: unknown): SerializedError {
  const err = ensureError(error)

  const serialized: SerializedError = {
    errName: err.name,
    errMessage: err.message,
    errMessages: getErrorMessages(err).join(' <- '),
    errStack: err.stack ?? null,
  }

  if (err instanceof TechnicalError && err.context !== undefined) {
    serialized['errContext'] = JSON.stringify(err.context)
  }

  if (isTRPCClientError(err)) {
    serialized['trpcCode'] = err.data?.code ?? null
    serialized['trpcHttpStatus'] = err.data?.httpStatus ?? null
    serialized['trpcPath'] = err.data?.path ?? null
  }

  return serialized
}

function getErrorMessages(error: Error): string[] {
  const errorMessages: string[] = []

  let currentError: Error | undefined = error
  while (currentError) {
    errorMessages.push(currentError.toString())
    currentError = currentError.cause instanceof Error ? currentError.cause : undefined
  }

  return errorMessages
}
